// extracted by mini-css-extract-plugin
export default {"container":"Invitations_container__rC8Q3","action":"Invitations_action__0XpM0","actionText":"Invitations_actionText__a29f2"};